import React, {useEffect, useRef, useState} from "react";
import AceEditor from "react-ace";
import "react-ace-builds/webpack-resolver-min";
import "ace-builds/src-noconflict/theme-chaos";
import "ace-builds/src-noconflict/theme-github";
import "ace-builds/src-noconflict/ext-language_tools.js";
import "./Editor.css"

const ace = require("ace-builds/src-noconflict/ace");
ace.config.set(
  "basePath",
  "https://cdn.jsdelivr.net/npm/ace-builds@1.4.3/src-noconflict/"
);
ace.config.setModuleUrl(
  "ace/mode/javascript_worker",
  "https://cdn.jsdelivr.net/npm/ace-builds@1.4.3/src-noconflict/worker-javascript.js"
);



export default function Editor(data) {
  const {value, onChange, lang, dark, readOnly, debugLine, exception, breakPoints, setBreakPoints} = data;
  const [markers, setMarkers] = useState(null); // 保存 markerId
  const [annotations, setAnnotations] = useState(null); // 保存 markerId
  let mode = lang;
  const editorRef = useRef(null);
  const breakPointsRef = useRef(null);
  if (lang === "c" || lang === "cpp" || lang === "systemverilog") {
    mode = "c_cpp";
  }else if (lang === "bash"){
    mode = "sh";
  }else if (lang === "vb"){
    mode = "vbscript";
  }else if (lang.indexOf("python") >= 0){
    mode = "python";
  }

  useEffect(() => {
    const editor = editorRef.current.editor;
    // 监听行号栏点击事件
    editor.on("gutterclick", handleGutterClick, true);

    return () => {
      // 移除事件监听（避免内存泄漏）
      editor.off("gutterclick", handleGutterClick);
    };
  }, []);
  useEffect(() => {
    if (debugLine){
      let lineIndex = debugLine-1;
      setMarkers([{startRow: lineIndex, startCol: 0, endRow: lineIndex, endCol: 1, className: 'custom-highlight', type: 'fullLine' }]);
      editorRef.current?.editor?.scrollToLine(lineIndex, true, true, () => {});
    }else{
      setMarkers([])
    }
  }, [debugLine]);
  useEffect(() => {
    if (exception){
      setAnnotations([
        {
          row: exception.line-1,
          column: 0,
          text: exception.exception_msg,
          type: "error"
        }
      ]);
    }else{
      setAnnotations([]);
    }
  }, [exception]);

  useEffect(() => {
    const editor = editorRef.current.editor; // 获取 Ace 实例
    const session = editor.getSession(); // 获取编辑会话
    if (breakPoints && breakPoints.length){
      session.setBreakpoints([...breakPoints].map(item => Number(item) - 1)); // 在第 2、4、6 行添加断点标记（0 基索引）
    }else{
      session.setBreakpoints([])
    }
    breakPointsRef.current = breakPoints;
  }, [breakPoints]);
  const handleGutterClick = (e) => {
    let line = e.domEvent?.target?.innerText
    const breakPointSet = new Set(breakPointsRef.current);
    if (line) {
      line = Number(line)
      if (breakPointSet.has(line)) {
        breakPointSet.delete(line);
      } else {
        breakPointSet.add(line);
      }
      setBreakPoints([...breakPointSet].map(Number))
    }
  }

  return (
      AceEditor && (
        <div className={"editor-container"}>
          <AceEditor
            ref={editorRef}
            mode={mode}
            width="100%"
            height="100%"
            overflow={"hidden"}
            theme={dark ? "chaos" : "github"}
            readOnly={readOnly}
            onChange={onChange}
            fontSize={14}
            showPrintMargin={true}
            showGutter={true}
            highlightActiveLine={true}
            value={value}
            wrapEnabled={true}
            markers={markers}
            annotations={annotations}

            setOptions={{
              useWorker: false,
              enableBasicAutocompletion: true,
              enableLiveAutocompletion: true,
              enableSnippets: true,
              showLineNumbers: true,
              showPrintMargin: false,
              tabSize: 2
            }}
          />
        </div>
    )
  );
}
